import { createDataWidget } from "@/widgets/common/createDataWidget";
import { mockFetch } from "@/widgets/common/mockFetch";
import { generatePrintColorRecords } from "../shared/records";
import { aggregateRecordsToWidthRows } from "./logic";
import type { PaperUsageRow } from "./types";

/**
 * Widget state via the shared factory (D11): thunk + slice + selectors in one
 * declaration. The fetcher aggregates the SHARED (width × color) records per
 * paper width — the same source the PrintedColorUsage widget aggregates per
 * color, so both charts tell one consistent story. Swapping in CubeJS
 * replaces `mockFetch` with a real fetcher.
 */
export const paperUsage = createDataWidget<PaperUsageRow, void>({
  name: "paperUsage",
  fetcher: mockFetch(() => aggregateRecordsToWidthRows(generatePrintColorRecords())),
});
